export default "__VITE_ASSET__806ad080__"